import React, {MouseEvent} from "react";
import styles from "@styles/components/button/index.module.scss";
import {withRedux} from "@redux/with-redux-store";
import {useDispatch, useSelector} from "react-redux";
import {addCustomBoxToCart, addToCartWithQuantity} from "@redux/action/cartActions";
import {toast} from "react-toastify";

export interface ButtonProps {
    children?: React.ReactNode;
    props?: any;
    classes?: string;
    disabled?: boolean | undefined
    selectedHoneyList: [];
    productLimit: 2,
    clearSelection?: any
}

const AddToCartButton: React.FC<ButtonProps> = ({
                                                    children,
                                                    selectedHoneyList = [],
                                                    productLimit,
                                                    clearSelection,
                                                    ...props
                                                }) => {

    /**
     * To manage cart data globally
     */
    const dispatch = useDispatch();
    // @ts-ignore
    const sidrCart = useSelector((state) => state.sidrCart);
    const handleOnClick = (e: MouseEvent<HTMLButtonElement>) => {

        let isBoxExist = false;
        for (const product of sidrCart.entities) {
            if (product.lineItem.customAttributes.length > 0) {
                isBoxExist = true;
            }
        }

        if(!isBoxExist){
            const uniqueId = `${productLimit}-box-${new Date().getTime()}`;
            // @ts-ignore
            if (selectedHoneyList.length == productLimit) {
                let productList = []
                for (const product of selectedHoneyList) {
                    // @ts-ignore
                    productList.push({...product.shopifyProduct, quantity: 5})
                }
                const payload = {
                    id: uniqueId,
                    type: `${productLimit}-box`,
                    products: productList,
                    isCustomBox: true
                }
                addCustomBoxToCart(payload, sidrCart, dispatch, () => {
                    if (clearSelection) {
                        clearSelection()
                    }
                })
            }
        } else {
            toast.info(`Maximum 1 gift box allowed.`, {
                toastId: '1',
                icon: ({theme, type}) => <img src="/assets/images/decorations/extra/ic_toast_message.svg" alt={'close'}/>
            })
        }
    };
    return (
        <button className={`${styles.button} ${props.classes ? props.classes : ''}`} disabled={props.disabled}
                onClick={handleOnClick} {...props}>
            {children}
        </button>
    );
};
export default withRedux(AddToCartButton);
